import React from 'react';
import styled from 'styled-components';
import { UserProfile, useClerk } from '@clerk/clerk-react';
import { Modal } from '../ui/index.js';
import { Button } from '../ui/index.js';
import { theme } from '../../../config/theme';

// Styled wrapper for Clerk's UserProfile component with minimal color and font customization
const ClerkUserProfileWrapper = styled.div`
  /* Only customize colors and fonts - let Clerk handle all sizing and layout */
  
  /* Remove Clerk's default padding/margin */
  .cl-userProfile-root {
    padding: 0 !important;
    margin: 0 !important;
  }
  
  /* Text colors and fonts */
  .cl-userProfile-root {
    color: ${theme.colors.primary.text};
    font-family: ${theme.typography.primary.fontFamily};
  }

  /* Headings */
  .cl-userProfile-root h1,
  .cl-userProfile-root h2,
  .cl-userProfile-root h3,
  .cl-userProfile-root h4 {
    font-family: ${theme.typography.primary.fontFamily};
    color: ${theme.colors.primary.text};
  }

  /* Body text */
  .cl-userProfile-root p,
  .cl-userProfile-root .cl-text {
    font-family: ${theme.typography.secondary.fontFamily};
    color: ${theme.colors.primary.text};
  }

  /* Buttons */
  .cl-button {
    font-family: ${theme.typography.button.fontFamily};
  }

  /* Primary buttons */
  .cl-button[data-variant="primary"],
  .cl-formButtonPrimary {
    background: ${theme.colors.primary.buttons};
    color: ${theme.colors.primary.background};
    
    &:hover:not(:disabled) {
      background: ${theme.colors.primary.buttonsHover || theme.colors.primary.buttons};
    }
  }

  /* Secondary/ghost buttons */
  .cl-button[data-variant="ghost"],
  .cl-button[data-variant="secondary"] {
    color: ${theme.colors.primary.buttons};
    border-color: ${theme.colors.primary.buttons};
    
    &:hover:not(:disabled) {
      background: ${theme.colors.primary.buttons};
      color: ${theme.colors.primary.background};
    }
  }

  /* Destructive buttons */
  .cl-button[data-variant="destructive"] {
    color: #ef4444;
    border-color: #ef4444;
    
    &:hover:not(:disabled) {
      background: #ef4444;
      color: ${theme.colors.primary.background};
    }
  }

  /* Links and interactive elements */
  .cl-link {
    color: ${theme.colors.accent.main};
  }

  /* Active navigation */
  .cl-navButton[data-active="true"] {
    color: ${theme.colors.accent.main};
    border-bottom-color: ${theme.colors.accent.main};
  }

  /* Form inputs and labels */
  .cl-input,
  .cl-formField input,
  .cl-formField select,
  .cl-formField textarea {
    font-family: ${theme.typography.primary.fontFamily};
    border-color: ${theme.colors.neutral.medium};
    
    &:focus {
      border-color: ${theme.colors.accent.main};
    }
  }

  .cl-formField label,
  .cl-label {
    font-family: ${theme.typography.secondary.fontFamily};
    color: ${theme.colors.primary.text};
  }

  /* Cards and backgrounds */
  .cl-card {
    background: ${theme.colors.primary.background};
    border-color: ${theme.colors.neutral.light};
  }

  /* Dividers */
  .cl-divider {
    background-color: ${theme.colors.neutral.light};
  }
`;

const LogoutSection = styled.div`
  padding: ${theme.spacing.md} 0 0 0;
  border-top: 1px solid ${theme.colors.neutral.light};
  display: flex;
  justify-content: center;
`;

const AccountPopup = ({ isOpen, onClose }) => {
  const { signOut } = useClerk();

  const handleLogout = () => {
    signOut();
    onClose();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      maxWidth="900px"
      style={{
        maxHeight: '85vh',
        overflow: 'hidden'
      }}
    >
      <div style={{ margin: '-32px', padding: '16px', height: 'calc(85vh - 64px)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto' }}>
          <ClerkUserProfileWrapper>
            <UserProfile />
          </ClerkUserProfileWrapper>
        </div>
        <LogoutSection style={{ marginTop: '16px', flexShrink: 0 }}>
          <Button
            onClick={handleLogout}
            variant="primary"
            size="medium"
          >
            Logout
          </Button>
        </LogoutSection>
      </div>
    </Modal>
  );
};

export default AccountPopup;